const merge = require('lodash/merge');
const parseRequestMetaData = require('../../utils/parse-request-meta-data');
const SEPERATOR = require('../../utils/constants');
const base64 = require('base-64');
const apiConfig = require('../../api-config');

function apiFactory({
  baseUrl,
  requestHandler
}) {
  const headers = {
    Accept: 'application/json'
  };

  function getUrl(endpoint) {
    return `${baseUrl}${endpoint}`;
  }

  return {

    getUserIdDetails(inputParam, metaData) {
      const url = getUrl('userId');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };
      const params = inputParam.split(SEPERATOR.SEPERATOR);
      const email = params[0];
      const ipAddress = params[1];
      const isRMGroup = params[2];
      const isRMUpdate = params[3];
      const moduleName = params[4];

      const body = {
        email: email,
        ipAddress: ipAddress,
        isRMGroup: isRMGroup,
        isRMUpdate,
        moduleName
      }

      return requestHandler(merge(reqOpts, {
        url,
        body
      }));
    },

    getSmartCardURL(metaData) {
      const url = getUrl('getSmartCardUrl');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };

      const body = {};

      return requestHandler(merge(reqOpts, {
        url,
        body
      }));
    },

    clearOtherSession(inputParam, metaData) {
      const url = getUrl('clearOtherSession');
      const parsedMetaData = parseRequestMetaData(metaData);

      const params = inputParam.split(SEPERATOR.SEPERATOR);

      const xLoggedUser = { Accept: 'application/json', 'x-loggedin-user': params[0] }

      const reqOpts = {
        headers: merge(xLoggedUser, parsedMetaData.headers),
        method: 'POST',
        json: true
      };

      const userId = params[0];
      const channel = params[1];

      const body = {
        userId: userId,
        channel: channel
      }

      return requestHandler(merge(reqOpts, {
        url,
        body
      }));
    },

    smartCardLoginFailed(inputParam, metaData) {
      const url = getUrl('smartCardLoginFailed');
      const parsedMetaData = parseRequestMetaData(metaData);

      const params = inputParam.split(SEPERATOR.SEPERATOR);

      const xLoggedUser = { Accept: 'application/json', 'x-loggedin-user': params[0] }

      const reqOpts = {
        headers: merge(xLoggedUser, parsedMetaData.headers),
        method: 'POST',
        json: true
      };

      const userId = params[0];
      const action = params[1];

      const body = {
        userId,
        action
      }

      return requestHandler(merge(reqOpts, {
        url,
        body
      }));
    }
  };
}

module.exports = apiFactory;
